import { uiRouterStateModule } from '../../vendor/ui-router-module';
import { getAccountService } from '../../utils/account-utils/account-utils';

export const stateHelperModule = angular
  .module('Q.helpers.state-helper', [uiRouterStateModule])

  /**
   * Provides some simple helpers for dealing with uiRouter $state issues
   */
  .factory(
    'stateHelper',
    function ($state, $q, $rootScope, $injector, $timeout) {
      const stateHelper = {
        /**
         * Redirects immediately during a resolve, by rejecting the current resolve.
         * This style redirect only works if you don't care about the current state name or parameters.
         *
         * @example
         *
         * resolve: {
         *     foo(stateHelper) {
         *         if(test) {
         *             return stateHelper.redirectInResolve('someState', { param: true });
         *         } // else like normal
         *     }
         * }
         *
         * @param state State to redirect to (required)
         * @param params {*?} Parameters for the state (optional)
         * @param options {*?} Options for $state.go (optional)
         * @returns {Promise}
         */
        redirectInResolve(state, params, options) {
          return $q.reject({ redirectTo: { state, params, options } });
        },

        /**
         * Redirects after a state change. Only redirects if the state change is successful.
         * This uses scope events to detect a successful state change, and redirects at that time.
         * If there's a state change error, the redirect is canceled.
         *
         * @param state State to redirect to (required)
         * @param params {*?} Parameters for the state (optional)
         * @param options {*?} Options for $state.go (optional)
         */
        redirectAfterResolve(state, params, options) {
          $rootScope.stateHelperRedirecting = true;
          let unWatchSuccess;
          let unWatchError;
          unWatchSuccess = $rootScope.$on('$stateChangeSuccess', () => {
            unWatchError();
            unWatchSuccess();
            $timeout(() => {
              $rootScope.stateHelperRedirecting = false;
              $state.go(state || '.', params, options);
            });
          });
          unWatchError = $rootScope.$on('$stateChangeError', () => {
            unWatchError();
            unWatchSuccess();
            $rootScope.stateHelperRedirecting = false;
          });
        },

        /**
         * Enables automatic redirecting to the default filter or user's preference if no filter is
         * defined.
         *
         * @param stateName
         * @param stateFilters
         * @returns {*|Promise}
         */
        defaultFilters(stateName, stateFilters) {
          const filterId = stateName + 'StateFilter';
          let redirectParams = false;
          if (!$state.activeParams[filterId]) {
            // switch to users or systems default route

            // set to default in case we can't use the user's
            redirectParams = { [filterId]: stateFilters.default.id };

            let accountService = getAccountService($injector);
            let defaultViews = {};
            if (accountService) {
              defaultViews = accountService.prefs().defaultviews || {};
            }
            if (defaultViews[stateName]) {
              let params = defaultViews[stateName];
              // only redirect if it's a valid state filter, to prevent immediate 404s
              if (
                stateFilters.find((filter) => filter.id === params[filterId])
              ) {
                // assume we can handle all the other params without completely breaking
                redirectParams = params;
              }
            }
          }

          if (redirectParams) {
            // using active state prevents us from breaking deeper redirects
            let updatedState = $state.activeState || stateName;
            // merge the default params with any active params
            let updatedParams = angular.extend(
              {},
              $state.activeParams,
              redirectParams,
            );
            return stateHelper.redirectInResolve(updatedState, updatedParams);
          }
        },
      };

      return stateHelper;
    },
  );
